import * as React from 'react'

import { useUnsafeEffect } from 'modules/core/hooks/useEffect'

interface TableBodyRect {
  width: number
  height: number
}

interface Props {
  tableHeadRef: React.RefObject<HTMLTableSectionElement>
  tableBodyRef: React.RefObject<HTMLTableSectionElement>
  tableContainerRef: React.RefObject<HTMLDivElement>
  loading: boolean
}

const useResizeVirtualizeTable = ({
  tableHeadRef,
  tableBodyRef,
  tableContainerRef,
  loading,
}: Props) => {
  const [tableBodyRect, setTableBodyRect] = React.useState<TableBodyRect>({ height: 0, width: 0 })

  useUnsafeEffect(() => {
    if (loading) return

    const resizeTableBody = () => {
      if (tableHeadRef.current && tableBodyRef.current) {
        const tableHeadRect = tableHeadRef.current.getBoundingClientRect()
        const tableContainerRect = tableContainerRef.current?.getBoundingClientRect()
        const height = tableContainerRect?.height || 0 - tableHeadRect.bottom
        const width = tableHeadRect.width

        tableBodyRef.current.style.height = `${height}px`
        tableBodyRef.current.style.width = `${width}px`

        setTableBodyRect({ height, width })
      }
    }

    resizeTableBody()

    window.addEventListener('resize', resizeTableBody)

    return () => {
      window.removeEventListener('resize', resizeTableBody)
      window.removeEventListener('load', resizeTableBody)
    }
  }, [loading, tableBodyRef, tableHeadRef])

  return { tableBodyRect }
}

export default useResizeVirtualizeTable
